// extracted by mini-css-extract-plugin
export default {"title":"index_title_8qcYh","info":"index_info_8nKef","content":"index_content_26N5p"};